/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiIcon20Regular = forwardRef('NetConnectWifiIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 5.25a9.75 9.75 0 0 0-7.215 3.192.75.75 0 0 1-1.11-1.009 11.25 11.25 0 0 1 16.65 0 .75.75 0 1 1-1.11 1.009A9.75 9.75 0 0 0 10 5.25Z" }),
        React.createElement("path", { d: "M10 10.25a4.75 4.75 0 0 0-3.65 1.71.75.75 0 0 1-1.153-.959 6.25 6.25 0 0 1 9.606 0 .75.75 0 1 1-1.153.96A4.75 4.75 0 0 0 10 10.25Z" }),
        React.createElement("path", { d: "M10 16.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" })));
});
